module.exports = __webpack_public_path__ + "img/Wallet.a7e048be.svg";